import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './grupoEmailForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista
} from './grupoEmailActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class GrupoEmail extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			nome: 1
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form tratativa onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form tratativa excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${item.nome} ${item.emails.join(' ')}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		});

		if (this.state.ordenacao.nome) {
			lista.sort((a, b) => this.state.ordenacao.nome == 1 
				? (a.nome > b.nome ? 1 : -1) 
				: (a.nome > b.nome ? -1 : 1));
		} 

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 180}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 180}px`
										: `${window.innerHeight - 110}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 180}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 180}px`
										: `${window.innerHeight - 110}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome: this.getNovaOrdenacao(this.state.ordenacao.nome) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignLeft>Nome {this.getIconeOrdenacao(this.state.ordenacao.nome)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>E-mails</Th>
									<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignLeft small minWidth={180}>{item.nome}</Td>
										<Td color="#000" small alignCenter>
											<div
												style={{
													display: 'flex',
													flexWrap: 'wrap',
													gap: 4,
													justifyContent: 'center'
												}}
											>
												{(item.emails || []).length > 0 ? (
													item.emails.map((email, index) => (
														<span
															key={index}
															style={{
																display: 'inline-block',
																padding: '2px 8px',
																borderRadius: 12,
																background: '#eef3ff',
																color: '#424242',
																fontSize: 12,
																fontWeight: 500,
																border: '1px solid #cfdcff'
															}}
														>
															<i
																className="fa fa-envelope"
																style={{ marginRight: 4 }}
															/>
															{email}
														</span>
													))
												) : (
													<span style={{ color: '#999' }}>-</span>
												)}
											</div>
										</Td>
										<Td minWidth={50} width={150} alignCenter>
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('exclusao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.grupoEmail.aguardando,
	modoTela: state.grupoEmail.modoTela,
	lista: state.grupoEmail.lista,
	filtro: state.grupoEmail.filtro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GrupoEmail);
